/* eslint-disable prettier/prettier */
// export const Server = 'http://localhost:8000'
// export const websiteURl = 'http://localhost:3000'
export const Server = 'https://www.softtechhub.sbtstudentshop.ch/softtechhub-backend'
export const websiteURl = 'https://softtechhub-website-nextjs.vercel.app'
